import { clsx } from 'clsx';

export type RetailerTab = 'retailers' | 'nearby';

type RetailerTabsHeaderProps = {
  currentTab: RetailerTab;
  onChange: (tab: RetailerTab) => void;
  retailersTabHidden?: boolean;
  retailersLabel: string;
  nearbyLabel: string;
};

const RetailerTabsHeader: React.FC<RetailerTabsHeaderProps> = ({
  currentTab,
  onChange,
  retailersTabHidden,
  retailersLabel,
  nearbyLabel,
}) => {
  return (
    <div className="bg-grey-100 font-li flex p-0-4 rounded-8-0 text-2-0 md:text-1-4 mx-2-0 mb-2-0">
      <div
        className={clsx(
          'w-full px-1-2 py-0-8 mr-1-0 cursor-pointer transition-bg duration-200 ease-linear',
          currentTab === 'retailers'
            ? 'text-primary-black bg-primary-white rounded-8-0 shadow'
            : 'text-grey-700',
          retailersTabHidden && 'hidden',
        )}
        onClick={() => onChange('retailers')}
      >
        {retailersLabel}
      </div>
      <div
        className={clsx(
          'w-full px-1-2 py-0-8 cursor-pointer transition-bg duration-200 ease-linear',
          currentTab === 'nearby'
            ? 'text-primary-black bg-primary-white rounded-8-0 shadow'
            : 'text-grey-700',
        )}
        onClick={() => onChange('nearby')}
      >
        {nearbyLabel}
      </div>
    </div>
  );
};

export default RetailerTabsHeader;
